import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	projectPagesItem: {
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.project-pages-item',
		defaultMessage: 'Project pages',
		description: '"Project pages" in a classic software project.',
	},
	edit: {
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.edit',
		defaultMessage: 'Edit',
		description: 'Edit button for pages.',
	},
	editProjectPages: {
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.edit-project-pages',
		defaultMessage: 'Edit project pages',
		description: 'Label of edit button for pages.',
	},
	pagesItem: {
		id: 'navigation-apps-shortcuts-sidebar.pages-menu-item.pages-item',
		defaultMessage: 'Pages',
		description: '"Pages" in a business project.',
	},
});
